<form [formGroup]="dataForm" class="without-default-focus">
	<div class="form-item form-item-help">
		<mat-form-field>
			<input matInput data-input-description type="text" placeholder="Data" formControlName="data" autocomplete="off" required tabindex="11" />
			@if (dataForm.errors && dataForm.errors['data'].required && (dataForm.controls['data']?.dirty || dataForm.controls['data'].touched)) {
				<mat-error data-input-title-error>Le champ 'Data' est obligatoire</mat-error>
			}
		</mat-form-field>
	</div>
</form>
